<template>
  <div>
    <label class="typo__label">Table Data</label>
    <multiselect
      v-model="statTableSelected"
      select-label=""
      deselect-label=""
      track-by="id"
      label="text"
      :preselect-first="true"
      :options="table_data_options"
      :searchable="false"
      :show-labels="false"
      placeholder=""
      :allow-empty="false">
      <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'StatTableSelect',
  components: {
    Multiselect
  },
  props: ['value', 'options'],
  data () {
    return {
      table_data_options: this.options,
      stat_table_selected: this.value
    }
  },
  computed: {
    statTableSelected: {
      get () {
        return this.stat_table_selected
      },
      set (value) {
        this.stat_table_selected = value
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value: function (val) {
      this.statTableSelected = val
    },
    options: function (val) {
      this.table_data_options = val
      if (this.$route.query.Table) {
        this.table_data_options.forEach((tableDataOption) => {
          if (this.$route.query.Table === tableDataOption.id) {
            this.statTableSelected = tableDataOption
          }
        })
      }
      if (!this.statTableSelected) {
        this.statTableSelected = val[0]
      }
    }
  },
  methods: {
    setStatTableSelected () {
      this.stat_table_selected = undefined
      this.table_data_options.forEach((tableDataOption) => {
        if (tableDataOption.id === this.$route.query.Table) {
          this.stat_table_selected = tableDataOption
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/StatTableSelect.vue